import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { db } from "./lib/instant";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Orders from "./pages/Orders";
import Login from "./pages/Login";
import Profile from "./pages/Profile";
import Invoice from "./pages/Invoice";
import Search from "./pages/Search";
import NotFound from "./pages/NotFound";
import { About, Contact } from "./pages/AboutContact";
import WhatsAppFloat from "./components/WhatsAppFloat";

function CustomerApp() {
  const { data } = db.useQuery({ settings: {} });
  const settings = data?.settings?.[0] || {};

  const [theme, setTheme] = useState({
    primaryColor: "#6b2118",
    accentColor: "#c9a84c",
    secondaryColor: "#2e7d32",
  });

  useEffect(() => {
    if (settings.primaryColor) {
      setTheme({
        primaryColor: settings.primaryColor,
        accentColor: settings.accentColor || "#c9a84c",
        secondaryColor: settings.secondaryColor || "#2e7d32",
      });
    }
    // Update favicon dynamically
    if (settings.faviconUrl) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
      link.href = settings.faviconUrl;
    }
    // Update page title
    if (settings.metaTitle) document.title = settings.metaTitle;
  }, [settings.primaryColor, settings.faviconUrl, settings.metaTitle]);

  // Maintenance mode
  if (settings.maintenanceMode) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 20, background: "#fdf6e3" }}>
      <div style={{ fontSize: "4rem" }}>🔧</div>
      <h1 style={{ fontFamily: "Georgia, serif", color: "#2c1810" }}>Under Maintenance</h1>
      <p style={{ color: "#888" }}>We'll be back shortly. Thank you for your patience!</p>
      <div style={{ color: "#999", fontSize: "0.9rem" }}>📞 {settings.storePhone || "98403 20932"}</div>
    </div>
  );

  return (
    <AuthProvider>
      <CartProvider>
        <Navbar theme={theme} settings={settings} />
        <main>
          <Routes>
            <Route path="/" element={<Home theme={theme} />} />
            <Route path="/shop" element={<Shop theme={theme} />} />
            <Route path="/product/:id" element={<ProductDetail theme={theme} />} />
            <Route path="/cart" element={<Cart theme={theme} />} />
            <Route path="/checkout" element={<Checkout theme={theme} />} />
            <Route path="/orders" element={<Orders theme={theme} />} />
            <Route path="/login" element={<Login theme={theme} />} />
            <Route path="/profile" element={<Profile theme={theme} />} />
            <Route path="/invoice/:id" element={<Invoice theme={theme} />} />
            <Route path="/search" element={<Search theme={theme} />} />
            <Route path="/about" element={<About theme={theme} />} />
            <Route path="/contact" element={<Contact theme={theme} />} />
            <Route path="*" element={<NotFound theme={theme} />} />
          </Routes>
        </main>
        <Footer theme={theme} />
        <WhatsAppFloat theme={theme} />
      </CartProvider>
    </AuthProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" toastOptions={{ style: { borderRadius: 12, fontFamily: "inherit", fontSize: "0.9rem" } }} />
      <CustomerApp />
    </BrowserRouter>
  );
}
